import { ListItem } from "@mui/material";

import MultiSelectSearchV3 from "./MultiSelectSearchV3";

export default function LawFirmFilter({
  selectedItems,
  setSelectedItems,
  setActiveItems,
  activeItems,
  resetPagination,
  setFilterState,
}) {
  const setSelectedState = (selectedValues) => {
    setSelectedItems(selectedValues);
    setFilterState({ fieldName: "lawFirmFilter", data: selectedValues });
  };

  return (
    <ListItem>
      <div className="w-full p-2 shadow">
        <MultiSelectSearchV3
          title="Filter by Law Firm"
          searchTitle="Law Firm Search"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedState}
          setActiveItems={setActiveItems}
          activeItems={activeItems}
          resetPagination={resetPagination}
          nameKey={"name"}
          valueKey={"pk"}
          apiUrl={`/api/lawfirm/?`}
          buttonFullW={true}
          dropdown={false}
        />
      </div>
    </ListItem>
  );
}
